var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCashbackbronzeicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.57,
    height: 109.57,
    viewBox: "0 0 109.57 109.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    width: 109.57,
    height: 109.57,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M54.786,8.194A46.591,46.591,0,1,1,8.194,54.786,46.644,46.644,0,0,1,54.786,8.194m0-8.194A54.785,54.785,0,1,0,109.57,54.786,54.786,54.786,0,0,0,54.786,0",
    transform: "translate(0 0)",
    fill: "#ffb668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M71.816,77.429c.066,2.584-1.472,3.529-3.944,2.264C62.617,77,57.347,74.33,52.213,71.425a4.776,4.776,0,0,0-5.405.011c-4.84,2.755-9.837,5.235-14.774,7.821a12.426,12.426,0,0,1-1.5.7c-2.074.751-3.5-.184-3.3-2.382.234-2.574.722-5.129,1.157-7.686.694-4.076,1.483-8.138,2.1-12.225a2.863,2.863,0,0,0-.75-2.125c-4.378-4.378-8.833-8.681-13.265-13.009a11.2,11.2,0,0,1-.908-.963c-1.6-2-1-3.731,1.558-4.167,3.7-.628,7.418-1.12,11.127-1.673,2.785-.414,5.56-.895,8.352-1.213a2.2,2.2,0,0,0,1.934-1.45c2.633-5.405,5.312-10.79,7.978-16.18.243-.494.46-1.005.747-1.475,1.322-2.163,3.256-2.2,4.481.029,1.352,2.464,2.529,5.024,3.775,7.545,1.687,3.414,3.325,6.85,5.086,10.226a2.628,2.628,0,0,0,1.669,1.207c6.373,1.017,12.77,1.887,19.135,2.948,1.013.168,2.516.937,2.689,1.682a4.1,4.1,0,0,1-1.25,3.1C78.431,46.64,73.9,51.026,69.344,55.38a2.568,2.568,0,0,0-.8,2.637c1.084,6.025,2.12,12.057,3.163,18.089.075.436.078.882.112,1.322",
    transform: "translate(5.371 5.039)",
    fill: "#ffb668"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbackbronzeicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/cashback.bronze.icon.0a8153fc59c2a133dc0cb299ceb861bb.svg";
export { ForwardRef as ReactComponent };